/**
 * format.ts — rene formatingshjelpere for visning
 *
 * Separation of concerns: disse funksjonene ENDRER IKKE data — de formatterer
 * kun for visning. Rådata fra backend brukes uendret der det er nødvendig
 * (sortering, lagring, sammenligning), mens visningslaget kan bruke disse.
 *
 * Innhold:
 * 1. capitalizeFirstLetter — stor forbokstav, resten uendret
 */

/**
 * 1. capitalizeFirstLetter — returnerer teksten med stor forbokstav.
 *
 * Backend-leverte verdier (f.eks. username fra JWT) endres IKKE i kilden —
 * denne brukes kun i visningslaget.
 *
 * NB: Ingen fallback. Ved tom streng/null/undefined returneres input uendret.
 *
 * @param text — teksten som skal formateres
 * @returns teksten med stor forbokstav (resten uendret)
 */
export function capitalizeFirstLetter(text: string): string {
  if (text.length === 0) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
}
